import resourceService from './resource_service';

const modelName = 'site';

const attributes = {
  name: '',
  account: '',
  address: '',
  state: '',
  country: '',
  zipcode: '',
  timeZone: '',
  isMetric: '',
};

const relationships = {
  chemicalManufacturer: {
    jsonApi: 'hasOne',
    update: true,
  },
  permissions: {
    jsonApi: 'hasMany',
  },
  siteAbilities: {
    jsonApi: 'hasMany',
  },
};

export default resourceService(modelName, attributes, relationships);
